import AutosizeInput, { AutosizeInputProps } from 'react-input-autosize';
import { twMerge } from 'tailwind-merge';

import { cn } from '../lib';
import { Heading } from './heading';
import { Skeleton } from './skeleton';
import { Typography } from './typography';

interface AmountWithFeeAutosizeInputProps extends AutosizeInputProps {
  amount?: string;
  fee: string | null;
  currencySymbol?: string;
  className?: string;
  errorText?: string;
  isLoading?: boolean;
}
export const AmountWithFeeAutosizeInput = ({
  amount,
  fee,
  currencySymbol,
  className,
  onChange,
  placeholder,
  errorText,
  isLoading,
}: AmountWithFeeAutosizeInputProps) => {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <div className="mx-auto flex w-fit items-center">
        <Heading
          className={twMerge('font-black', !!errorText && 'text-negative-500')}
          variant="l"
          tag="span"
        >
          {currencySymbol}
        </Heading>
        <AutosizeInput
          name="amount"
          value={amount ? amount : ''}
          placeholder={placeholder ?? '10'}
          autoFocus
          autoComplete="off"
          onChange={onChange}
          inputClassName={twMerge(
            'bg-surface-00-transparent pl-1 font-right-grotesk font-black uppercase outline-none text-[48px] leading-[46px] -tracking-[0.48px] max-w-[240px] h-[46px] placeholder:text-base-100',
            !!errorText && 'text-negative-500',
          )}
        />
      </div>
      {errorText ? (
        <Typography
          variant="14-r"
          color="text-base-100"
          className="text-center"
        >
          {errorText}
        </Typography>
      ) : isLoading ? (
        <Skeleton className="mx-auto h-[14px] w-[100px]" />
      ) : (
        Boolean(amount && fee) && (
          <Typography
            variant="14-r"
            color="text-base-100"
            className="text-center"
          >
            Fees: {fee}&#8239;{currencySymbol}
          </Typography>
        )
      )}
    </div>
  );
};
